// extracted by mini-css-extract-plugin
module.exports = {"pcContact":"pcContact___2z3eJ","mobileContact":"mobileContact___pgTOn"};